import React, { useEffect, useState } from 'react';
import { Box, Button, Card, CardContent, Chip, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import client from '../api/client';
import { useCart } from '../context/CartContext';

export default function CoursesPage() {
  const [courses, setCourses] = useState([]);
  const { items: cartItems, addItem } = useCart();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    client.get('/courses').then(r => setCourses(r.data)).catch(console.error);
  }, []);

  function isInCart(courseId) {
    return cartItems.some(i => i.itemId === courseId);
  }

  function handleAddToCart(course) {
    addItem({ itemId: course.courseId, title: course.title, price: course.price, type: 'COURSE' }, 1);
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 3 }}>{t('courses.title')}</Typography>
      {courses.length === 0 && (
        <Typography color="text.secondary">{t('courses.noCourses')}</Typography>
      )}
      <Grid container spacing={2}>
        {courses.map(course => (
          <Grid item xs={12} sm={6} md={4} key={course.courseId}>
            <Card>
              <CardContent>
                <Typography variant="h6">{course.title}</Typography>
                {course.description && (
                  <Typography color="text.secondary" gutterBottom>{course.description}</Typography>
                )}
                {course.purchaseState !== 'OWNED_ACCESSIBLE' && course.purchaseState !== 'OWNED_PENDING' && (
                  <Typography sx={{ mt: 1 }}>{course.price} {course.currency}</Typography>
                )}
                <Box sx={{ mt: 2 }}>
                  {course.purchaseState === 'PURCHASABLE' && (
                    isInCart(course.courseId)
                      ? <Chip label={t('courses.inCart')} color="success" />
                      : <Button variant="contained" onClick={() => handleAddToCart(course)}>
                          {t('courses.addToCart')}
                        </Button>
                  )}
                  {course.purchaseState === 'SALES_CLOSED' && (
                    <Chip label={t('courses.salesClosed')} color="default" />
                  )}
                  {course.purchaseState === 'OWNED_ACCESSIBLE' && (
                    <Button variant="contained" color="success"
                            onClick={() => navigate(`/courses/${course.courseId}`)}>
                      {t('courses.openCourse')}
                    </Button>
                  )}
                  {course.purchaseState === 'OWNED_PENDING' && (
                    <Typography variant="body2" color="text.secondary">
                      {t('courses.accessOpens', { date: course.accessStartsOn
                        ? new Date(course.accessStartsOn).toLocaleDateString()
                        : '' })}
                    </Typography>
                  )}
                  {course.purchaseState === 'OWNED_EXPIRED' && (
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography variant="body2" color="text.secondary">{t('courses.accessExpired')}</Typography>
                      {isInCart(course.courseId)
                        ? <Chip label={t('courses.inCart')} color="success" />
                        : <Button variant="outlined" onClick={() => handleAddToCart(course)}>
                            {t('courses.addToCart')}
                          </Button>
                      }
                    </Box>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
